<template >
  <div class="bg-sub2">
    <div class="header-page container">
      <h4 class="header-history"><i class="fa fa-fighter-jet"></i> รายการแนะนำ</h4>
      <div class="recommended-content">
        <section class="cards" >
          <div class="card-recommended" v-for="item in recommended">
            <div class="" @click="PlayRecommendedContent(item)">
              <div class="preview-video">
                <figure class="sixteen-nine-img">
                  <p class="duration">{{item.duration}}</p>
                  <img :src="item.thumb" />
                  <div class="btn-overlay">
                    <fa icon="play" class="icon-play"/>
                  </div>
                </figure>
              </div>
              <div class="card-content">
                <p class="card-title">{{ item.name }}</p>
                <p class="card-date">ดูทั้งหมด {{ Number(item.views).toLocaleString() }} คน</p>
                <p class="card-desc">{{ item.desc }}</p>
              </div>
            </div>

            <!--div class="function">
              <btn class="btn-fav" type="submit" name="button"  @click="FunctionFavorite(item)">
                <fa icon="heart" class="" v-bind:class="[FavoriteActive(item.favorite) ? 'icon-fav' : 'icon-fav2']"/>
              </btn>
              <btn class="btn-history" type="submit" name="button" @click="AddWatchLater(item)"><fa icon="history" class="icon-history" /></btn>
              <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLink(item)"><fa icon="share" class="icon-share"/></btn>
            </div-->
          </div>
        </section>
      </div>

      <!-- Modal share -->
        <modal centered v-if="modalShare" @close="modalShare = false">
          <!--fa class="close-modal" color="danger" icon="close"@click.native="modalShare = false" /-->
      <modal-header>
        <modal-title >แชร์ลิ้งค์</modal-title>
      </modal-header>
      <modal-body>
        <div class="padding-share">
          <!--div class="text-center input-share">
            <input type="text" class="form-control shareLink" name="" value="" v-model="Link" disabled>
          </div-->
            <div class="input-link input-share">
              <input type="text" v-model="Link" id="linkURL" class="form-control shareLink" readonly="readonly">
              <btn color="primary" class="btn-chat" @click="CopyLink()"><span>คัดลอก</span></btn>
            </div>
          <!--div class="">
            <btn class="btn-email" color="white"><fa icon="envelope" class="icon-link" /> อีเมล</btn>
          </div>
          <div class="">
            <btn class="btn-facebook" color="primary"><fa icon="facebook" class="icon-social" /> facebook</btn>
          </div>
          <div class="">
            <btn class="btn-line" color=" green accent-4"><fa icon="line" class="icon-social" />Line</btn>
          </div-->
        </div>

      </modal-body>
        </modal>
        <!-- /Modal share -->
    </div>
  </div>

</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
import {
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  Btn,
  Fa,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter
} from 'mdbvue';

export default {
  name: 'RecommendedPage',
  components: {
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    Btn,
    Fa,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter
  },
  data() {
    return {
      Link: '',
      modalShare: false,
      recommended: []
    };
  },
  mounted() {
    this.RecommendedFeed();
    this.ToggleLogin();
    localStorage.pincode = '';
    this.Session();
  },
  methods: {
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession , {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
      }
      this.modalLogin = true;
    },
    ShareLink(data) {
      this.Link = data.share;
    },
    FavoriteActive(fav) {
      if (fav === "true") {
        return true;
      }
      return false;
    },
    FunctionFavorite(data) {
      if (data.favorite == 'true') {
        this.DelFavorite(data);
      } else {
        this.AddFavorite(data);
      }
    },
    DelFavorite(data) {
      let APIgetDelFavorite = Host + '/api/v1/favorite/delete';
      axios.post(APIgetDelFavorite , {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        this.RecommendedFeed();
      });
    },
    AddFavorite(data) {
      let APIgetAddFavorite = Host + '/api/v1/favorite/add';
      axios.post(APIgetAddFavorite , {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        this.RecommendedFeed();
      });
    },
    AddWatchLater(data) {
      let APIgetAddWatchLater = Host + '/api/v1/watchlater/add';
      axios.post(APIgetAddWatchLater , {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        console.log(data.id);
      });
    },
    RecommendedFeed() {
      let APIgetRecommendedFeed = Host + '/api/v1/video/recommended';
      axios.post(APIgetRecommendedFeed ,{
        email: localStorage.emailfront
      }).then(response => {
        this.recommended = response.data.result;
      });
    },
    PlayRecommendedContent(data) {
      document.location.assign('/#/vod/' + data.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  }
};
</script>

<style lang="css">
</style>
